// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1Kt7E","overflowing":"ReadFullNote_overflowing__3a7YP"};